<template>
  <div class="connect-dialog">
    <el-dialog title="收藏位号" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
      <div class="connect-dialog_tree">
        <el-tree
          :data="initData"
          accordion
          highlight-current
          node-key="id"
          :props="defaultProps"
          @node-click="handleNodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="babel" @click="()=>clickFN(node,data)">
              <i class="el-icon-folder"></i>
              <span>{{ node.label }}</span>
            </span>
          </span>
        </el-tree>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="okFN()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ApiService from "@/services/API-services";
import "@/common/css/scrollbar.css";
import eventBus from "./../../../eventBus/eventBus.js";
export default {
  name: "collectionTree",
  data() {
    return {
      dialogVisible: true,
      ID: JSON.parse(localStorage.getItem("user")),
      BitNumber: localStorage.getItem("BitNumber"),
      initData: [],
      currentOBJ: "null",
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  // props: [],
  created() {
    //  eventBus.$on('setMuster',(data)=>{
    //    console.log("setMuster",data)
    //  });

    console.log("collection Tree MusterMusterMuster", window.Muster);
  },
  methods: {
    cancel() {
      this.$store.commit("closeModal", "collectionTree");
    },
    async okFN() {
      //收藏到一个目录
      console.log(this.currentOBJ, "okFN", this.currentOBJ == "null");
      if (this.currentOBJ == "null") {
        this.$message({
          message: "请选择文件夹",
          type: "warning"
        });
        this.$store.commit("closeModal", "collectionTree");
        return;
      }

      if (!window.Muster) {
        this.$message({
          message: this.$t('docMgt.noData'),
          type: "warning"
        });
        this.$store.commit("closeModal", "collectionTree");
        return;
      }

      ApiService.collect
        .addFile({
          pdi: this.currentOBJ.data.id, // 父级id
          //  "CollectionName": this.BitNumber,//收集的名称
          userID: this.ID.userId,
          bitNumber: window.Muster,
          mileageID: window.R_config.modelId,
          DdtaType: 2 // 右击 区域 就是文件夹
        })
        .then(res => {
          console.log("res", res);

          this.$store.commit("closeModal", "collectionTree");
          this.$message({
            message: res.msg,
            type: res.code == 0 ? "success" : "warning"
          });

          res.code == 0
            ? (async () => {
                eventBus.$emit("updateFileList", "哈哈");
              })()
            : (async () => {
                this.$message({
                  message: res.msg,
                  type: "warning"
                });
              })();
        })
        .catch(err => {
          console.log(err);
        });
    },
    clickFN(node, data) {
      console.log(node, data);
      this.currentOBJ = {
        node,
        data
      };

      console.log(" this.currentOBJ", this.currentOBJ);
    },
    handleNodeClick(data) {
      console.log(data);
    }
  },
  created() {
    console.log("currentElement ", window.currentElement);

    console.log(this.ID);

    ApiService.collect
      .getAllFileLIst({
        userID: this.ID.userId,
        DataType: 1, //文件
        mileageID: window.R_config.modelId,
      })
      .then(data => {
        console.log("getAllFileLIst", data);
        if (data.code == 300) {
          this.initData = [];
        } else {
          this.initData = data.data;
          // 删除子集type = 2 数据
          const arr = [];
          const myData = this.initData;
          console.log("myData", myData);
          myData.findIndex(current => {
            console.log(current);
          });
        }

        const newChild = {
          id: 0,
          label: "收藏夹",
          icon: 1,
          flag: true,
          val: "收藏夹",
          children: []
        };

        this.initData.unshift(newChild);
      })
      .catch(err => {
        console.log("err", err);
      });
  }
};
</script>
<style lang ="scss" scoped>
$color-deault: #f1f1f1;
$color-base: #666666;
$color-weight: #333333;
$color-active: #0078d7;
$fontsize-default: 14px;
$fontsize-middle: 16px;
$bg-hover: #ebebeb;
.connect-dialog {
  .connect-dialog_tree {
    ::v-deep {
      .el-tree-node:focus > .el-tree-node__content {
        background-color: red !important;
      }

      .is-current {
        .el-tree-node__content {
          background: red!important;
        }
      }

      .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
        color: $color-weight !important;
      }

      .el-tree-node__content {
        color: $color-weight;
        font-size: $fontsize-middle;
        &:hover {
          color: $color-active;
          background: $bg-hover;
        }
      }

      .el-dialog__header {
        background: #0078d7;
        text-align: left;
        .el-dialog__title {
          color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/collection/collectionTree.vue